'use strict';

import React from 'react';

import FormElement from './FormElement/FormElement';
import SubmitRow   from './SubmitRow/SubmitRow';


const Form = ({ form, submit, cancel, section, height, width, element, onschedState }) => {
  const [columns, setColumns] = React.useState([]);

  React.useEffect(() => {
    const splitArr = Object.keys(form).reduce((acc, curr, i) => {
      if ( !(i % 2)  ) {
        // leftside
        if (form[curr]?.fullcolumn) {
          // leftside is fullcol
          // push one for whole row
          acc.push([Object.keys(form)[i]]);
        }
        else if (form[Object.keys(form)[i + 1]]?.fullcolumn)  {
          // next col is fullcol
          // push one for both this row and next
          acc.push([Object.keys(form)[i]]);
          acc.push([Object.keys(form)[(i + 1)]]);
        }
        else {
          // neither this nor next col is fullcol
          // push tow for this row
          acc.push(Object.keys(form).slice(i, i + 2));
        }
      }
      return acc;
    }, []);

    setColumns(splitArr);
  }, [form])

  return (
    <form className='Form' onSubmit={submit}>
      {columns.map((col, idx) => 
        <div key={idx} className='FormColumn'>
          { col.map((formInputKey, i) => <FormElement key={i} form={form} onschedState={onschedState} formInputKey={formInputKey} /> )}
        </div>
      )}

      { submit && <SubmitRow element={element} height={height} width={width} cancel={cancel} section={section} /> }
    </form>
  )
};

export default Form;
